<section class="post-header">
  <div *ngIf="prevPage.hasHistory()" class="back" (click)="onClickBack()">
      <em class="icon-left_small"></em><span class="hide-on-mobile">Back</span>
  </div>
  <div class="title-element">
      <span class="truncate-paragraph-ellipsis line-clamp-2">{{reportTitle}}</span>
  </div>
</section>
<div *ngIf="!htmlReport" class="loading-container">
  <app-progress-bar-circular/>
</div>
<app-generic-toolbar
  *ngIf="htmlReport && toolbarOptions[0].getOptions().length > 0"
  [toolbarOptions]="toolbarOptions"
  [addRightMargin]="true">
</app-generic-toolbar>
<app-hygraph
  *ngIf="htmlReport"
  class="sectioned-blogs"
  [reportTitle]="reportTitle"
  [htmlReport]="htmlReport"
  [lockedMessage]="lockedMessage"
  [showTableOfContent]="false"
  [selectedStage]="selectedStage"
  [isContentLoading]="isContentLoading"
  [fitWidth]="fitWidth"
  [isBlog]="true"
  (stageChange)="handleStageChange($event)"
  #hygraph
></app-hygraph>
<app-promo-banner></app-promo-banner>
